module.exports = __webpack_public_path__ + "static/media/s15.ca8235ac.png";